export function fetchCampaigns(state, { page, sort, filter }) {
  return {
    ...state,
    campaigns: {
      ...state.campaigns,
      currentPage: page,
      sort: sort || state.campaigns.sort,
      filter: filter || state.campaigns.filter,
    },
  };
}

export function fetchCampaignsSuccess(state, { campaigns, filter }) {
  const pluck = (field) => campaigns.items.map((campaign) => {
    const value = campaign[field];
    return { label: value, value };
  });

  return {
    ...state,
    campaigns: {
      ...state.campaigns,
      numberOfPages: campaigns.numberOfPages,
      count: campaigns.count,
      items: campaigns.items,
    },
  };
}

export function fetchCampaignsByCountrySuccess(state, { campaigns }) {
  return {
    ...state,
    campaignsByCountry: {
      ...state.campaignsByCountry,
      items: campaigns,
    },
  };
}

export function fetchCampaignsByCategorySuccess(state, { campaigns }) {
  return {
    ...state,
    campaignsByCategory: {
      ...state.campaignsByCategory,
      items: campaigns,
    },
  };
}

export function fetchCampaignDetailsSuccess(state, campaign) {
  return {
    ...state,
    campaign,
  };
}

export function fetchCampaignsNames(state) {
  return {
    ...state,
    campaigns: {
      ...state.campaigns,
      names: [],
    },
  };
}

export function fetchCampaignsNamesSuccess(state, names) {
  return {
    ...state,
    campaigns: {
      ...state.campaigns,
      names,
    },
  };
}

export function fetchCampaignsIds(state) {
  return {
    ...state,
    campaigns: {
      ...state.campaigns,
      ids: [],
    },
  };
}

export function fetchCampaignsIdsSuccess(state, ids) {
  return {
    ...state,
    campaigns: {
      ...state.campaigns,
      ids,
    },
  };
}

export function fetchCampaignsCountries(state) {
  return {
    ...state,
    campaigns: {
      ...state.campaigns,
      countries: [],
    },
  };
}

export function fetchCampaignsCountriesSuccess(state, countries) {
  return {
    ...state,
    campaigns: {
      ...state.campaigns,
      countries,
    },
    playables: {
      ...state.playables,
      countries,
    },
  };
}

export function updateCampaignSuccess(state, { campaignId, revShare, capping }) {
  const campaignIndex = state.campaigns.items.findIndex(x => x._id === campaignId);
  const campaign = state.campaigns.items.find(x => x._id === campaignId);
  if (!campaign) {
    return state;
  }
  return {
    ...state,
    campaigns: {
      ...state.campaigns,
      items: [
        ...state.campaigns.items.slice(0, campaignIndex),
        {
          ...campaign,
          revShare,
          capping,
        },
        ...state.campaigns.items.slice(campaignIndex + 1),
      ],
    },
  };
}

export function openEditCampaign(state, campaign) {
  return {
    ...state,
    editCampaign: {
      ...campaign,
      showModal: true,
    },
  };
}

export function closeEditCampaign(state) {
  return {
    ...state,
    editCampaign: {
      showModal: false,
    },
  };
}

export function updatePostbackSuccess(state, { appId, postback }) {
  const appIndex = state.apps.findIndex(x => x._id === appId);
  const app = state.apps.find(x => x._id === appId);
  if (!app) {
    return state;
  }
  return {
    ...state,
    apps: [
      ...state.apps.slice(0, appIndex),
      {
        ...app,
        postback,
      },
      ...state.apps.slice(appIndex + 1),
    ],
    app: {
      ...app,
      postback,
    },
  };
}



/** WEBPACK FOOTER **
 ** ./js/core/campaigns.js
 **/